
import { combineEpics } from "redux-observable";
import * as homeEpics from "../features/home/epic";
import * as completionEpics from "../features/completion/epic";
import * as cancelEpics from "../features/cancelled/epic"

// Combine all the exported epic using their key.
const values = (data: any) => Object.keys(data).map(key => data[key]);
export default combineEpics(...values(homeEpics), ...values(completionEpics), ...values(cancelEpics));